// basic vue2 component
<template>
  <b-container>
    <b-row>
      <b-col lg="8">
        <h1>{{ this.user.name_display }}</h1>
        <h2>{{ this.user.title }}</h2>
        <hr>
        <p>{{ this.user.bio }}</p>
      </b-col>
      <b-col>
        <b-list-group>
          <b-list-group-item v-if="this.user.status == 0">Deactivated</b-list-group-item>
          <b-list-group-item><a :href="`mailto:${this.user.email}`">{{ this.user.email }}</a></b-list-group-item>
          <b-list-group-item><a :href="`tel:${this.user.phone}`">{{ this.user.phone }}</a></b-list-group-item>
        </b-list-group>
        <b-button variant="primary" class="mt-3" block @click="startDirectMessage">
          <font-awesome-icon :icon="['fas', 'message']" /> Send Direct Message
        </b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import UserDataService from '@/services/UserDataService';
import InboxDataService from '@/services/InboxDataService';
export default {
  data() {
    return {
      user: {}
    }
  },
  created() {
    UserDataService.getProfileById(this.$route.params.id).then((res) => {
      this.user = res.data;
    })
  },
  methods: {
    startDirectMessage() {
      const targetUserId = this.$route.params.id;

      InboxDataService.create({
        subject: 'direct',
        body: '',
        participants: [targetUserId, 'self']
      }).then((res) => {
        const inboxId = res.id || res.data?.id;
        window.location = `/inbox/message/${inboxId}`;
      });
    }
  }
}
</script>